import moment from 'moment';
import { nanoid } from 'nanoid';

export const chartData =
  (name) =>
  (request) =>
  ({ report }, meta) => ({
    [name]: meta.dates.map((range, index) => ({
      rid: nanoid(),
      request: {
        ...request,
        dates: meta.dates,
      },
      range: { start: moment(range.start), end: moment(range.end) },
      data:
        report &&
        report.data.rows
          .filter(({ dates }) => dates[index])
          .map(({ dimensions, dates, metrics }) => ({
            key: moment(dates[index]),
            value: metrics[index].values[0],
          })),
    })),
  });

export const tableData =
  (name) =>
  (request) =>
  ({ report }, { offset = 0, dates, sort }) => ({
    [name]: {
      request: {
        ...request,
        dates,
      },
      meta: {
        sort: report.header.sort,
        total: report.data.totalRowCount,
        offset,
        limit: 10,
        dates,
      },
      data: report.data.rows.map((row) => ({
        ...report.header.metrics.reduce(
          (acc, metric, index) => ({
            ...acc,
            [metric.name]: row.metrics[0].values[index],
          }),
          {}
        ),
        ...report.header.dimensions.reduce(
          (acc, dimension, index) => ({
            ...acc,
            [dimension]: row.dimensions[index],
          }),
          {}
        ),
      })),
    },
  });
